import { Expose, Type } from 'class-transformer';
import { Point } from 'geojson';

import { Default, ExposeRawData } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

export class FsEagleEyeRead extends SnModel {
  @Expose()
  @Type(() => Date)
  public createdTimestamp: Date;

  @Expose()
  @Type(() => Date)
  public eventTimestamp: Date;

  @ExposeRawData()
  public details: any;

  @ExposeRawData()
  public geometry: Point;

  @Expose()
  public id: string;

  @Expose()
  public cameraId: string;

  @Expose()
  public plate: string;

  @Expose()
  public confidence: string;

  @Expose()
  public lat: number;

  @Expose()
  public lon: number;

  @Expose()
  public plateImageUrl: string;

  @Expose()
  public overviewImageUrl: string;

  @Expose()
  public type: string;

  @Expose()
  public organization: string;

  @Expose()
  public vehicleMake: string;

  @Expose()
  public vehicleModel: string;

  @Expose()
  public vehicleYear: string;

  @Expose()
  public vehicleColor: string;

  @Expose()
  @Default('eagleeye')
  public integratedLprType: string = 'eagleeye';

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
